$(document).ready(function () {
  console.log("Product script loaded ✅");

  (function (bodyScrollLock, themeCurrency, Flickity, FlickityFade, Ajaxinate, FlickityAsNavFor, Rellax) {

    // Safe formatter
    const formatMoney = (amount) => {
      try {
        return themeCurrency.formatMoney(amount, theme.moneyWithoutCurrencyFormat);
      } catch (e) {
        console.warn("Fallback formatter used");
        return `£${(amount / 100).toFixed(2)}`;
      }
    };

    // One-Time Purchase
    $(document).on('click', '.oneTimePurchase', function () {
      console.log("Clicked One-Time");
      $('.product__form-block .qty__adjust').removeClass("hidden");
      $("input[name='selling_plan']").val('');

      const price = $(this).data("product-price");
      const priceMoney = $(this).data("price-money");

      const formatted = formatMoney(price);
      $("#variant_price").text(formatted).attr("data-price-money", priceMoney);

      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', 1).val("1");
      $(".qty__adjust-btn--minus").prop("disabled", false);
    });

    // 14-Day Subscription
    $(document).on('click', '.subAndSave:not(.delivery-every-4-weeks)', function () {
      console.log("Clicked 14-day subscription");
      $('.product__form-block .qty__adjust').addClass("hidden");

      const sellingId = $(this).data("selling-id");
      $("input[name='selling_plan']").val(sellingId);

      const price = $(this).data("selling-price");
      const priceMoney = $(this).data("price-money");

      const formatted = formatMoney(price);
      $("#variant_price").text(formatted).attr("data-price-money", priceMoney);

      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', 1).val("1");
      $(".qty__adjust-btn--minus").prop("disabled", false);
    });

    // 28-Day Subscription (simulated)
    $(document).on('click', '.subAndSave.delivery-every-4-weeks', function () {
      console.log("Clicked 28-day (qty 2)");
      $('.product__form-block .qty__adjust').addClass("hidden");

      const sellingId = $(this).data("selling-id");
      $("input[name='selling_plan']").val(sellingId);

      const unitPrice = $(this).data("price-money");
      const qty = 2;
      const total = unitPrice * qty;
      const formatted = formatMoney(total);

      $("#variant_price").text(formatted).attr("data-price-money", unitPrice);

      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', 2).val("2");
      $(".qty__adjust-btn--minus").prop("disabled", true);
    });

    // Quantity change
    $(document).on('change', '.qty__adjust-input', function () {
      const qty = parseInt($(this).val()) || 1;
      const is28 = $(".subAndSave.delivery-every-4-weeks.active").length > 0;

      if (is28 && qty < 2) {
        $(this).val(2);
        $(".qty__adjust-btn--minus").prop("disabled", true);
        return;
      }

      const unitPrice = $("#variant_price").data("price-money");
      const formatted = formatMoney(unitPrice * qty);
      $("#variant_price").text(formatted);
    });

    // Quantity +/- button click
    $(document).on('click', '.qty__adjust-btn', function () {
      const qty = parseInt($(".qty__adjust-input").val()) || 1;
      const is28 = $(".subAndSave.delivery-every-4-weeks.active").length > 0;

      if (is28 && qty <= 2) {
        $(".qty__adjust-btn--minus").prop("disabled", true);
      }

      const unitPrice = $("#variant_price").data("price-money");
      const formatted = formatMoney(unitPrice * qty);
      $("#variant_price").text(formatted);
    });

    // Meta Pixel params to cart
    const form = document.querySelector('form[action^="/cart"]');
    if (form) {
      const fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))?.split('=')[1] || '';
      const fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1] || '';

      if (fbp) {
        const fbpInput = document.createElement('input');
        fbpInput.type = 'hidden';
        fbpInput.name = 'attributes[_fbp]';
        fbpInput.value = fbp;
        form.appendChild(fbpInput);
      }

      if (fbc) {
        const fbcInput = document.createElement('input');
        fbcInput.type = 'hidden';
        fbcInput.name = 'attributes[_fbc]';
        fbcInput.value = fbc;
        form.appendChild(fbcInput);
      }
    }

  }(
    themeVendor.BodyScrollLock,
    themeVendor.themeCurrency,
    themeVendor.Flickity,
    themeVendor.FlickityFade,
    themeVendor.ajaxinate,
    themeVendor.FlickityAsNavFor,
    themeVendor.Rellax
  ));
});
